
// import MyPictures from './pictures';
import { StyleSizeType, StyleColorSchemeType } from '@/ui-kit/styles/enums';
import Button from '@/ui-kit/components/button';
import { ButtonFillType } from '@/ui-kit/components/button/enums';
import ModalService from '@/ui-kit/components/modal/ModalService';
import { ToastMessage } from '@/ui-kit/components/toast/enums';
import { getAction, UPDATE_FAVOURITE_NOTES } from '@/store/listings/actions';
import ToastService from '@/components/toast/toast-service';
import MyNotes from './notes';

export default {
  name: 'NotesPicturesComponent',
  components: {
    Button,
  },
  props: {
    listing: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      StyleColorSchemeType,
      StyleSizeType,
      ButtonFillType,
    };
  },
  methods: {
    async handleModalNotesClick() {
      const { notes, address, unit } = this.listing;
      const notesResult = await ModalService.open({
        component: MyNotes,
        data: {
          notes,
          address,
          unit,
        },
      });

      if (notesResult) {
        await this.saveNotes(notesResult);
      }
    },
    async saveNotes(notes) {
      await this.$store.dispatch(
        getAction(UPDATE_FAVOURITE_NOTES),
        {
          listingId: this.listing.listingId,
          notes,
        },
      );
      ToastService.openPositive(ToastMessage.FavouriteUpdated);
    },
    // TODO: When S3 bucket is ready for pictures modal we can re-use this service
    // handleModalPicturesClick() {
    //   return ModalService.open({
    //     component: MyPictures,
    //     data: {
    //       listing: this.listing,
    //       saveImages: (result) => this.saveImages(result),
    //     },
    //   });
    // },
    // async saveImages(result) {
    //   API CALL FOR IMAGE STORAGE TO GO HERE
    //   ToastService.openPositive(ToastMessage.FavouriteImageSaved);
    // },
  },
};
